// extracted by mini-css-extract-plugin
export default {"logoClockPreview":"styles_logoClockPreview__XtfU7","broadcasterLogo":"styles_broadcasterLogo__EzSdF","clockLogo":"styles_clockLogo__EcxqH"};